import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const PencilRulerIcon = createIcon({
  displayName: 'PencilRulerIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <rect width="24" height="24" fill="none" />
      <path
        d="M6,10,3.82841,7.82842a2.82843,2.82843,0,0,1,0-4h0a2.82842,2.82842,0,0,1,4,0L10,6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="5"
        y1="9"
        x2="9"
        y2="5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18,14l1.70891,1.70891a2,2,0,0,1,.54695,1.022L20.99,20.40166a.5.5,0,0,1-.58835.58835l-3.67077-.73415a2,2,0,0,1-1.022-.54695L14,18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.76,10.76,7.82,20.7a1.026,1.026,0,0,1-1.45,0L3.3,17.63a1.026,1.026,0,0,1,0-1.45L16.18,3.3a1.026,1.026,0,0,1,1.45,0L20.7,6.37a1.026,1.026,0,0,1,0,1.45Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="15.12132"
        y1="6.63604"
        x2="13.98265"
        y2="5.49736"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="12.7929"
        y1="9.96447"
        x2="11.15422"
        y2="8.32579"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.46447"
        y1="12.2929"
        x2="8.32579"
        y2="11.15422"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="7.13604"
        y1="15.62132"
        x2="5.49736"
        y2="13.98264"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const PencilRuler: FC<IconProps> = (props) => {
  return <CustomIcon as={PencilRulerIcon} {...props} />
}

export default memo(PencilRuler)
